var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
import { base64 } from "../base64";
export class Log {
    constructor(logger, applicationName) {
        this._logger = logger;
        this._applicationName = applicationName;
        const credentials = this.getClientCredentials();
        if (credentials !== null) {
            const encodedBasic = base64.encode(`${credentials.user}:${credentials.password}`);
            this._client = axios.create({
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Basic ${encodedBasic}`,
                },
                baseURL: credentials.server,
            });
        }
    }
    getClientCredentials() {
        const user = process.env.REACT_APP_LOG_USER;
        const password = process.env.REACT_APP_LOG_PASSWORD;
        const server = process.env.REACT_APP_LOG_SERVER;
        if (user === undefined || password === undefined || server == undefined)
            return null;
        return {
            user: user,
            password: password,
            server: server,
        };
    }
    logToServer(level, message, args) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (args === undefined || args === null)
                return;
            yield ((_a = this._client) === null || _a === void 0 ? void 0 : _a.post("Logger", {
                application: this._applicationName,
                class: args.className,
                method: args.methodName,
                level: level,
                message: message,
            }).then((resp) => resp.status).catch((err) => err));
        });
    }
    formatMessage(message, args) {
        if (args !== undefined && args !== null)
            message = `[${args.className}] [${args.methodName}] ` + message;
        return message;
    }
    debug(message, args) {
        this.logToServer("Debug", message, args);
        this._logger.debug(this.formatMessage(message, args));
    }
    info(message, args) {
        this.logToServer("Information", message, args);
        this._logger.info(this.formatMessage(message, args));
    }
    warn(message, args) {
        this.logToServer("Warning", message, args);
        this._logger.warn(this.formatMessage(message, args));
    }
    error(message, args) {
        this.logToServer("Error", message, args);
        this._logger.error(this.formatMessage(message, args));
    }
    fatal(message, args) {
        this.logToServer("Fatal", message, args);
        this._logger.fatal(this.formatMessage(message, args));
    }
}
